import { Accordion, Box, Button, Flex, Icon, Input } from "@chakra-ui/react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import Search from "@/assets/svg/search.svg";
import { Spinner } from "@/components/ui/Spinner";
import { useActions } from "@/hooks/useActions";
import { useGrowingFilters } from "@/hooks/useGrowingFilters";
import contentSelectors from "@/store/content/content.selectors";

import Filter from "../../../ui/Filter";


function SideBar({ filtersList }) {
  const isLoading = useSelector(contentSelectors.getIsLoading());

  return (
    <Flex
      p={"20px"}
      w={{ base: "100%", lg: "248px" }}
      bgColor={"white"}
      borderRadius={"10px"}
      pointerEvents={isLoading ? "none" : "auto"}
      minH={
        (filtersList?.length ?? 0) > 0 ? "fit-content" : "calc(100vh - 320px)"
      }
      flexDir={"column"}
      justify={"center"}
    >
      {filtersList && filtersList.length > 0 ? (
        <>
          <Box display={{ base: "none", lg: "block" }}>
            <SearchByKey />
          </Box>
          <Accordion defaultIndex={[0]} allowMultiple>
            {filtersList?.map((item) => {
              return <Filter key={"filterBlock" + item?.name} {...{ item }} />;
            })}
          </Accordion>
        </>
      ) : (
        <Flex w={"full"} justify={"center"} align={"center"} py={"30px"}>
          <Spinner customStyle={{ h: "30px" }} />
        </Flex>
      )}
    </Flex>
  );
}

export function SearchByKey() {
  const { handlerInputKey } = useGrowingFilters();
  const { setGrowingFiltersText } = useActions();
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      search: "",
    },
  });

  const onSubmitHandler = ({ search }) => {
    handlerInputKey({ searchTerm: search });
    reset();
    setGrowingFiltersText("");
  };

  return (
    <>
      <Controller
        control={control}
        name="search"
        render={({ field }) => (
          <Flex
            align={"center"}
            as={"form"}
            borderRadius={"4px"}
            borderWidth={"1px"}
            ps={"12px"}
            borderColor={"grey"}
            h={"40px"}
            onSubmit={handleSubmit(onSubmitHandler)}
          >
            <Input
              variant={"unstyled"}
              placeholder="Filter by keyword..."
              _placeholder={{ paddingTop: "9px" }}
              {...field}
            />
            <Button variant={"unstyled"} type="submit">
              <Icon as={Search} />
            </Button>
          </Flex>
        )}
      />
    </>
  );
}

export default SideBar;
